"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9635],{

/***/ 79635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var hub_helpers_contentful__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55352);






function ContentfulImage(_param) {
    var src = _param.src, width = _param.width, height = _param.height, _layout = _param.layout, layout = _layout === void 0 ? "responsive" : _layout, _alt = _param.alt, alt = _alt === void 0 ? "" : _alt, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "src",
        "width",
        "height",
        "layout",
        "alt"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        alt: alt,
        src: (0,hub_helpers_contentful__WEBPACK_IMPORTED_MODULE_3__/* .getContentfulImageUrl */ .l)(src),
        width: width,
        height: height,
        layout: layout,
        objectFit: "cover",
        quality: "85"
    }, restProps));
}
/* harmony default export */ __webpack_exports__["default"] = (ContentfulImage);


/***/ })

}]);